import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {DataStoreService} from "../../shared/services/api/data-store.service";
import {Subscription} from "rxjs";
import {Customer} from "../../shared/models/customer";
import {cursorTo} from "readline";
import {FormControl} from "@angular/forms";
import {Appointment} from "../../shared/models/appointment";
import * as moment from "moment";
import {Report} from "../../shared/models/report";
import {AppointmentCreateComponent} from "../../appointment/appointment-create/appointment-create.component";
import {MatDialog} from "@angular/material";
import {NavigationService} from "../../shared/services/navigation-service";
import {Site} from "../../shared/models/site";

@Component({
  selector: 'app-customer-view',
  templateUrl: './customer-view.component.html',
  styleUrls: ['./customer-view.component.scss']
})
export class CustomerViewComponent implements OnInit {

  public customer: Customer;
  public futureAppointments: Appointment[];
  public reports: Report[] = [];

  public navService = NavigationService;

  constructor(private route: ActivatedRoute,
              private dialog: MatDialog,
              public router: Router,
              private dataStore: DataStoreService) {
  }
  ngOnInit() {
    this.route.data.subscribe((data: { customer: Customer }) => {
      this.customer = data.customer;

      this.dataStore.findAll(Appointment, {
        filter: { customer: this.customer.id}
      }).subscribe(document => {
        let appointments = document.getModels();
        this.futureAppointments = appointments
           .filter(appointment => moment(appointment.date_time).isAfter(moment()));
        this.reports = appointments.filter(appointment => appointment.report != null).map(a => a.report);
      });
    }, (error) => console.error(error)); // TODO proper error handling
  }

  calcCenterFromCoordinates() {
    if (this.customer.sites.length > 0 && this.customer.sites[0].address) {
      return {lat: this.customer.sites[0].address.lat, lng: this.customer.sites[0].address.lng}
    } else {
      return {lat: 0, lng: 0}
    }
  }

  createReport(site: Site) {
    let dialogRef = this.dialog.open(AppointmentCreateComponent, {
      data: {
        day: moment(),
        selectedSite: site
      }
    });
    dialogRef.afterClosed().subscribe((appointment: Appointment) => {
      if (appointment != null && appointment.id) {
        this.router.navigate(["/appointment", appointment.id, "report"])
      }
    });
  }

  resizeMap(map: any) {
    window.setTimeout(() => map.triggerResize(), 100);
  }

}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/customer/customer-view/customer-view.component.ts